import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { fadeInUp } from "../../utils/animations";
import Button from "../../components/common/Button/Button";
import { ROUTES } from "../../constants/routes";
import styles from "./CommunityForumPage.module.css";

const CommunityForumPage = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.page}>
      <section className={styles.pageHeader}>
        <img
          src="/images/pages/CommunityForum page.webp"
          alt=""
          aria-hidden="true"
          className={styles.heroBgImage}
          fetchPriority="high"
          decoding="sync"
          loading="eager"
        />
        <div className={styles.heroOverlay} />
        <div className={styles.container}>
          <motion.div
            className={styles.headerContent}
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
          >
            <h1 className={styles.pageTitle}>
              {t("helpPages.communityForum")}
            </h1>
            <p className={styles.pageDescription}>
              {t("helpPages.communityForumDesc")}
            </p>
          </motion.div>
        </div>
      </section>

      <section className={styles.bodySection}>
        <div className={styles.container}>
          <motion.div
            className={styles.bodyContent}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
          >
            <div className={styles.placeholderCard}>
              <h2 className={styles.placeholderTitle}>
                {t("common.comingSoon")}
              </h2>
              <p className={styles.placeholderText}>
                {t("helpPages.communityForumPlaceholder")}
              </p>
              <Link to={ROUTES.SUPPORT}>
                <Button variant="secondary" size="large">
                  {t("helpPages.backToSupport", "Back to Support")}
                </Button>
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default CommunityForumPage;
